import React, { useContext } from 'react';
import { Col, Row, Table, Tag } from 'antd';
import {
    AuditOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    FileTextOutlined,
} from '@ant-design/icons';

import useCityTaxes from './useCityTaxes';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import KpiCard from '../../components/KpiCard';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function CityTaxes() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        columns,
        tableData,
        stats,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        navigate,
    } = useCityTaxes();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<AuditOutlined />}
                iconBg="linear-gradient(135deg, #1677ff 0%, #0958d9 100%)"
                title="Impostos Municipais"
                tag={<Tag color="blue">{poeValorComPontosEmMil(stats.total)} lançamentos</Tag>}
                subtitle="Acompanhe, valide e gerencie os comprovantes e lançamentos de tributos municipais dos cidadãos"
            />

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<FileTextOutlined />}
                        title="Total de Lançamentos"
                        value={poeValorComPontosEmMil(stats.total)}
                        accentColor="#1677ff"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<ClockCircleOutlined />}
                        title="Em Análise"
                        value={poeValorComPontosEmMil(stats.pending)}
                        accentColor="#faad14"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CheckCircleOutlined />}
                        title="Aprovados"
                        value={poeValorComPontosEmMil(stats.approved)}
                        accentColor="#52c41a"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CloseCircleOutlined />}
                        title="Recusados"
                        value={poeValorComPontosEmMil(stats.refused)}
                        accentColor="#ff4d4f"
                    />
                </Col>
            </Row>

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha para visualizar os detalhes do imposto ou utilize o botão de ação à direita." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="impostos"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/impostos/municipais/${record.id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="impostos"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
